"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const renderNutrientFacts_1 = require("./renderNutrientFacts");
const typography_1 = require("../../shared/typography");
const changeOrderInNutritionFacts_1 = require("./changeOrderInNutritionFacts");
const renderTranslationsLabels = (translations) => {
    return ((0, jsx_runtime_1.jsxs)(TranslationsWrapper, { children: [(0, jsx_runtime_1.jsx)("div", {}, void 0), (0, jsx_runtime_1.jsx)("div", { children: Object.entries(translations).map(([key, value]) => ((0, jsx_runtime_1.jsx)(typography_1.P, { children: value }, key))) }, void 0)] }, void 0));
};
exports.default = ({ meal, translations, unit }) => {
    var _a;
    return ((0, jsx_runtime_1.jsxs)(Container, { children: [renderTranslationsLabels((0, changeOrderInNutritionFacts_1.changeOrderInFactsTranslations)(translations)), (_a = meal.nutrients) === null || _a === void 0 ? void 0 : _a.map((0, renderNutrientFacts_1.renderNutrients)(unit, Boolean(meal.isMealPlan))), meal.image && (0, jsx_runtime_1.jsx)("img", { alt: "meal_photo", src: meal.image.thumbnail }, void 0)] }, void 0));
};
const Container = styled_components_1.default.div `
  & > div:not(:first-of-type):not(:last-of-type) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
  }

  img {
    margin-top: ${({ theme }) => theme.spacings.s};
    height: 350px;
    width: auto;
  }
`;
const TranslationsWrapper = styled_components_1.default.div `
  display: none;
  margin-bottom: ${({ theme }) => theme.spacings.xs};

  & > div:first-of-type {
    flex: 2;
  }

  & > div:last-of-type {
    flex: 3;
    display: flex;
    margin-right: ${({ theme }) => theme.spacings.l};
  }

  & > div:last-of-type p {
    flex: 1;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 0;
    text-transform: capitalize;
  }

  p:first-of-type {
    text-transform: lowercase;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    display: flex;

    & > div:last-of-type {
      flex: 7;
      margin-right: 0;
    }
  }
`;
//# sourceMappingURL=MealDetails.js.map